import { ProgressiveImg } from "@/components/progressive-img";

type TarotCardProps = {
	show: boolean;
	name?: string;
	isUpright: boolean;
	className?: string;
};
export function TarotCard({
	show,
	name,
	isUpright,
	className,
}: TarotCardProps) {
	return (
		<div className={`${className ?? ""} relative [perspective:1000px]`}>
			<div className="w-full pb-[172%]"></div>
			<div
				className={`
					absolute top-0 left-0 w-full h-full transition-transform duration-1000 [transform-style:preserve-3d]
					${show ? "[transform:rotateY(-180deg)]" : ""}`}
			>
				{/* Back */}
				<ProgressiveImg
					src={`/deck/back.jpg`}
					previewSrc={`/deck/back-preview.webp`}
					alt="card-back"
					className={`
						absolute w-full h-full inset-0 object-contain object-center
						[backface-visibility:hidden] rounded-xl shadow-lg border border-amber-900/20 bg-white
						z-10`}
				/>

				{/* Front */}
				{name && (
					<ProgressiveImg
						key={name}
						src={`/deck/${name}.jpg`}
						previewSrc={`/deck/${name}-preview.webp`}
						alt={name}
						className={`
							absolute w-full h-full inset-0 object-contain object-center [backface-visibility:hidden]
							rounded-xl shadow-lg border border-amber-900/20 bg-white
							z-0
							${
								isUpright
									? "[transform:rotateY(-180deg)]"
									: `[transform:rotateY(-180deg)_rotate(180deg)]`
							}`}
					/>
				)}
			</div>
		</div>
	);
}
